import { fieldTextStyles } from "../shared-styles";

export const autoCompleteTextFieldStyles = {
  "& .MuiOutlinedInput-root": {
    ...fieldTextStyles,
    paddingLeft: "8px",
    paddingRight: "8px",
    paddingTop: "6px",
    paddingBottom: "6px",
    minHeight: "38px",
    height: "auto",
    "& .MuiAutocomplete-tag": {
      margin: "2px",
      height: "24px",
      fontSize: "12px",
      "& .MuiChip-label": {
        paddingLeft: "8px",
        paddingRight: "8px",
        fontSize: "12px",
      },
      "& .MuiChip-deleteIcon": {
        fontSize: "16px",
        margin: "0 2px",
      },
    },
    "& .MuiAutocomplete-input": {
      minWidth: "30px !important",
      padding: "0 !important",
    },
  },
};
